import React from "react";
import { useTranslation } from "react-i18next";
const CameraView = () => {
  const { t } = useTranslation();
  return (
    <div className="cameraView">
      <div
        className="cameraViewTitle bg-white d-flex justify-content-between align-items-center m-auto py-3 px-2 position-relative"
        style={{ top: "30px" }}
      >
        <p className="m-0 fn">{t("اتاق خواب")}</p>
        <p className="m-0 fn12 muted">{t("14 دقیقه پیش")}</p>
      </div>
      <div
        className="d-flex flex-column align-items-center position-absolute mr-auto ml-auto"
        style={{ bottom: "160px", left: "0", right: "0" }}
      >
        <span className="cameraViewArows d-block icon-up text-center"></span>
        <div
          className="d-flex justify-content-between"
          style={{ width: "173px" }}
        >
          <span className="cameraViewArows icon-right-1 text-center d-block"></span>
          <span className="cameraViewArows icon-left text-center d-block"></span>
        </div>
        <span className="cameraViewArows icon-down text-center d-block"></span>
      </div>
      <div
        className="d-flex flex-wrap justify-content-center position-absolute"
        style={{ bottom: "30px", left: "0", right: "0" }}
      >
        <div className="mx-3 d-flex justify-content-center align-items-center flex-column text-center">
          <span className="profileAddUser bg-white d-block cursor icon-seti"></span>
          <small className="fn10 mt-1">{t("تنظیمات")}</small>
        </div>
        <div className="mx-3 d-flex justify-content-center align-items-center flex-column text-center">
          <span className="profileAddUser bg-white d-block cursor icon-off"></span>
          <small className="fn10 mt-1">{t("خاموش")}</small>
        </div>
        <div className="mx-3 d-flex justify-content-center align-items-center flex-column text-center">
          <span className="profileAddUser bg-white d-block icon-left-1 cursor"></span>
          <small className="fn10 mt-1">{t("بازگشت")}</small>
        </div>
      </div>
    </div>
  );
};

export { CameraView };
